import { render, staticRenderFns } from "./XtendInfo.vue?vue&type=template&id=6ee018d0&scoped=true&"
import script from "./XtendInfo.vue?vue&type=script&lang=js&"
export * from "./XtendInfo.vue?vue&type=script&lang=js&"
import style0 from "./XtendInfo.vue?vue&type=style&index=0&id=6ee018d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee018d0",
  null
  
)

export default component.exports